import { Link } from "react-router-dom";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function NotFound() {
  useDocumentTitle("页面不存在 - 啪啪视频");

  return (
    <div className="mx-auto flex min-h-[60vh] w-full max-w-2xl flex-col items-center justify-center px-4 py-20 text-center">
      <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-primary-50">
        <i className="ri-emotion-sad-line text-4xl text-primary-500"></i>
      </div>
      <h1 className="font-heading text-3xl font-bold text-foreground-950">404 · 页面走丢了</h1>
      <p className="mt-3 text-sm leading-relaxed text-foreground-500">
        你访问的页面不存在或已被移动，可能是链接输入有误。不如回到首页，继续发现精彩的高清视频。
      </p>
      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600"
        >
          返回首页
        </Link>
        <Link
          to="/search"
          className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-6 py-2.5 text-sm font-medium text-foreground-700 transition-colors duration-200 hover:border-primary-300 hover:text-primary-600"
        >
          去搜索视频
        </Link>
      </div>
    </div>
  );
}